import {connect} from "react-redux";
import UCDView from "./View";
import {bindActionCreators} from "redux";
import {ucdById} from "../../../../service/Dealer/action";
const mapStateToProps = (state) => ({
    ucdDetails:state.Dealer.ucdDetails,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ucdById
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(UCDView);
